import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHome = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.16667 12.6667H13.1667V6.6521L8.5 3.02247L3.83333 6.6521V12.6667H7.83333V8.66667H9.16667V12.6667ZM14.5 13.3333C14.5 13.7015 14.2015 14 13.8333 14H3.16667C2.79848 14 2.5 13.7015 2.5 13.3333V6.32605C2.5 6.12032 2.59498 5.92611 2.75737 5.79981L8.09073 1.65166C8.33147 1.46442 8.66853 1.46442 8.90927 1.65166L14.2426 5.79981C14.405 5.92611 14.5 6.12032 14.5 6.32605V13.3333Z", fill: "white" }));
const ForwardRef = forwardRef(SvgHome);
const Memo = memo(ForwardRef);
export default Memo;
